import { render, staticRenderFns } from "./MainPayService.vue?vue&type=template&id=fa0dd248&scoped=true"
import script from "./MainPayService.vue?vue&type=script&lang=ts"
export * from "./MainPayService.vue?vue&type=script&lang=ts"
import style0 from "./MainPayService.vue?vue&type=style&index=0&id=fa0dd248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../nhaphangtocdo/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0dd248",
  null
  
)

export default component.exports